<template>
  
    <Dialog :visible="visibility" modal :closable="false" :header="dialogHeader" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">   
        
        <!-- <div>
            
        </div> 
        <div v-if="loading">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>   -->
        
        <div class="grid">
            <div :class="loading? 'col-10' : 'col-12'">
                <div class="text-center ">
                    <FileUpload name="deptOrder" url="/api/uploads" accept=".pdf, image/*" :maxFileSize="31457280" @select="onFileSelect" @uploader="uploadDocument" :customUpload="true" :auto="false"></FileUpload>
                </div>
            </div>
            <div v-if="loading" class="col-1" >
                <div class="text-center ">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                </div>
            </div>
            
        </div>

        <template #footer>
            <div class="flex justify-content-end flex-wrap">
                <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="danger" text raised @click="closeDialog"></Button>
            </div>
        </template>
    </Dialog>
    

</template>

<script>
import { uploadDeptOrder, uploadRocDoc } from '@/services/apiService';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import FileUpload from 'primevue/fileupload';

export default {
    props:{
        visibility:Boolean,
        poId:String,
        poNo:String,
        documentType:String,
    },
    components:{
        FileUpload,
        Dialog,
        Button,
    },
    data(){
        return{
            dialogHeader:null,
            file:null,
            dialogVisible:this.visibility,
            flag:0,
            loading:false,
        }
    },
    methods:{
        onFileSelect(event){
            this.file = event.files[0];            
        },
        uploadDocument(){
            if(this.documentType=='order'){
                
                this.loading = true;
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('po_id', this.poId);
                // if(formData){
                //     return;
                // }
                uploadDeptOrder(formData).then((res)=>{
                    this.showSuccessToast(res.data)
                    this.flag = 1;
                    this.loading = false;
                    this.closeDialog();
                }).catch((error)=>{
                    this.showErrorToast(error.response.data);
                    this.loading = false;
                })            
            }
            else if(this.documentType=='roc'){
                
                this.loading = true;
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('roc_id', this.poId);

                uploadRocDoc(formData).then((res)=>{
                    this.showSuccessToast(res.data)
                    this.flag = 1;
                    this.loading = false;
                    this.closeDialog();
                }).catch((error)=>{
                    this.showErrorToast(error.response.data);
                    this.loading = false;
                })
            }
        },
        closeDialog(){
            this.dialogVisible = false;
            this.$emit('close-upload-dialog', this.dialogVisible, this.flag);
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
    },
    mounted(){
        if(this.documentType=='order'){
            this.dialogHeader = 'Order No.: '+this.poNo;
        }
        else if(this.documentType=='roc'){
            this.dialogHeader = 'ROC No.: '+this.poNo;
        }
    }

}
</script>

<style>

</style>